import { CSSProperties, FC } from "react";
import { PLANT } from "Constants";
import { useGetHistoryByIdQuery } from "Services";
import { useParams, useNavigate } from "react-router-dom";
import { Loader, Center } from "@mantine/core";


const cardStyle: CSSProperties = {
  background: "#fff",
  border: "1px solid #e6e6e6",
  padding: 16,
  borderRadius: 6,
};

const fieldStyle: CSSProperties = {
  display: "block",
  width: "100%",
  padding: "8px 10px",
  borderRadius: 4,
  border: "1px solid #d9d9d9",
  backgroundColor: "#f5f5f5",
  color: "#666",
};

const textareaStyle: CSSProperties = {
  ...fieldStyle,
  minHeight: 100,
  whiteSpace: "pre-line", 
};

const AdminHistoryView: FC = () => {
  const { id } = useParams<{ id: string }>();
  const historyId = Number(id);

  const navigate = useNavigate();

  const { data, isLoading, isError } = useGetHistoryByIdQuery(
    { id: historyId, plant: PLANT },
    { skip: !historyId }
  );

 
  if (isLoading) {
    return (
      <Center h={300}>
        <Loader />
      </Center>
    );
  }

  if (isError || !data) {
    return (
      <div style={{ padding: 24 }}>
        <p>History entry not found.</p>
        <button
          onClick={() => navigate("/admin/other-details/history")}
          style={{ marginTop: 12 }}
        >
          ← Back to History
        </button>
      </div>
    );
  }

  
  return (
  <>
    <button
      onClick={() => navigate("/admin/other-details/history")}
      className="text-blue-600 mb-3"
    >
      ← Back
    </button>

    <h3 className="mb-4 text-lg font-semibold">View History</h3>

    <div style={cardStyle}>
     
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label>Year</label>
          <input value={data.year} style={fieldStyle} disabled />
        </div>

        <div>
          <label>Title</label>
          <input value={data.title} style={fieldStyle} disabled />
        </div>
      </div>

      
      {data.description1 && (
        <div className="mt-6 border-t pt-4">
          <label className="font-medium">Description</label>
          <textarea
            value={data.description1}
            style={textareaStyle}
            disabled
          />
        </div>
      )}

      {data.description2 && (
        <div className="mt-6">
          <label className="font-medium">Description 2</label>
          <textarea
            value={data.description2}
            style={textareaStyle}
            disabled
          />
        </div>
      )}

      {data.description3 && (
        <div className="mt-6">
          <label className="font-medium">Description 3</label>
          <textarea
            value={data.description3}
            style={textareaStyle}
            disabled
          />
        </div>
      )}

    
      {data.imageUrl && (
        <div className="mt-6 border-t pt-4">
          <label className="block mb-2 font-medium">Image</label>
          <img
            src={data.imageUrl}
            alt={data.title}
            className="h-48 object-contain rounded border"
          />
        </div>
      )}

   
      <div className="mt-8 flex justify-end gap-3 border-t pt-4">
        <button
          type="button"
          onClick={() => navigate("/admin/other-details/history")}
          className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100"
        >
          Back to List
        </button>

        <button
          type="button"
          onClick={() =>
            navigate(`/admin/other-details/history/edit/${data.id}`, {
              state: { item: data, mode: "edit" },
            })
          }
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Edit History
        </button>
      </div>
    </div>
  </>
);

};

export default AdminHistoryView;
